import { CheckCircle2 } from "lucide-react";

export type PaymentVerificationStatus = "verifying" | "success" | "idle";

interface PaymentVerificationOverlayProps {
  open: boolean;
  status: PaymentVerificationStatus;
}

/** Full-screen overlay shown after Razorpay success while payment is verified on the server */
export function PaymentVerificationOverlay({
  open,
  status,
}: PaymentVerificationOverlayProps) {
  if (!open || status === "idle") {
    return null;
  }

  const isVerifying = status === "verifying";

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-2xl bg-card p-8 text-center shadow-2xl">
        {isVerifying ? (
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center">
            <div className="border-gold/25 h-14 w-14 animate-spin rounded-full border-4 border-t-gold" />
          </div>
        ) : (
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/10">
            <CheckCircle2 className="h-10 w-10 text-emerald-500" />
          </div>
        )}

        <h3 className="font-serif text-xl font-semibold text-primary">
          {isVerifying ? "Verifying your payment" : "Payment successful"}
        </h3>

        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
          {isVerifying
            ? "Please do not close this window or refresh the page."
            : "Thank you for your generous contribution."}
        </p>
      </div>
    </div>
  );
}
